/* global debounce */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.disclosure = this.closest('details');

      if (this.disclosure && this.disclosure.matches('.cart-note-disclosure')) {
        this.cartNoteToggle = this.disclosure.querySelector('.js-show-note');
      }

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };
      this.cartAttributes = [];
      fetch(theme.routes.cart+".js").then(c => c.json()).then((cart) => {
        this.cartAttributes = cart.attributes;
      })
      
      this.init();
    }

    init() {
      this.addEventListener('change', debounce((evt) => {
        if (this.cartNoteToggle) {
          const label = evt.target.value ? theme.strings.editCartNote : theme.strings.addCartNote;
          if (this.cartNoteToggle.textContent !== label) this.cartNoteToggle.textContent = label;
        }
        this.fetchRequestOpts.body = JSON.stringify({
          note: evt.target.value ,
          attributes: {
            ...this.cartAttributes,
            '_order_notes': evt.target.value ,
          }
          });
        fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
      }, 300));
    }
  }

  customElements.define('cart-note', CartNote);
}
document.addEventListener('DOMContentLoaded', function() {
  async function postData(url = "", data = {}) {
    // Default options are marked with *
    const response = await fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    });
    return response.json(); // parses JSON response into native JavaScript objects
  }


  // READ THIS!!!!!!
  // It's super important that this note gets passed to the attribute
  // or else the Pending payment method will show up from Shopify Script
  const setHiddenCartAttribute = async () => {
    const value = document.querySelector('[name="note"]').value;
    await fetch('/cart.js').then(c => c.json()).then(async (cart) => {
      const attributes = cart.attributes;
      await postData("/cart/update.js", { attributes:
            {
              ...attributes,
              '_order_notes': value,
            },
      })
    })
  }

  let isEventFiredOnce = false;

  function preventCartForm(e){
    e.preventDefault();
    e.stopImmediatePropagation();
    return false;
  }

  const cartForm = document.querySelector('#cart');
  if (cartForm) {
    cartForm.addEventListener('submit', preventCartForm, true);


    document.querySelectorAll('.cart.form button[name="checkout"]').forEach(function(button){
      if(button.getAttribute('listener') === 'true'){
        return;
      }

      async function eventListener(e) {
        button.removeEventListener('click', eventListener);
        if(isEventFiredOnce){
          return;
        }
        Promise.resolve().then(() => {
          // So this runs after event loop for the other event queued up which is 'submit'
          cartForm.removeEventListener('submit', preventCartForm, true);
        })
        isEventFiredOnce = true;
        e.preventDefault();
        e.stopImmediatePropagation();
        await setHiddenCartAttribute();
        button.click();
      }

      button.setAttribute('listener', 'true')
      isEventFiredOnce = false;
      button.addEventListener('click', eventListener, true)
    })
  }
})